module.exports = __webpack_public_path__ + "static/media/complete-image.69a7bcf4.svg";